/* Posie Re(Set) landing v4 — header state, sticky bar, plan selector,
   quote rotator, ingredient picker, float parallax. No dependencies. */
(function () {
  'use strict';

  var QUOTE_INTERVAL = 5500;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Meta Pixel helper: no-ops when the pixel is blocked or absent. */
  function fbTrack(method, name, params) {
    if (typeof window.fbq === 'function') window.fbq(method, name, params || {});
  }

  function init(root) {
    if (root.dataset.pv4Init === 'true') return;
    root.dataset.pv4Init = 'true';

    /* ----- Meta Pixel: CTA clicks toward the buy box ----- */
    root.querySelectorAll('a[href="#buy"]').forEach(function (cta) {
      cta.addEventListener('click', function () {
        fbTrack('trackCustom', 'GetMyKitClick', {
          cta_label: (cta.textContent || '').trim()
        });
      });
    });

    /* ----- header + sticky bar scroll state ----- */
    var sticky = root.querySelector('[data-pv4-sticky]');
    var floats = root.querySelectorAll('[data-float]');

    function onScroll() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var vh = window.innerHeight || 800;
      root.classList.toggle('is-scrolled', y > vh * 0.6);
      if (sticky) sticky.classList.toggle('is-visible', y > vh * 0.95);
      parallax(vh);
    }

    function parallax(vh) {
      if (reduceMotion) return;
      for (var i = 0; i < floats.length; i++) {
        var el = floats[i];
        var sp = parseFloat(el.getAttribute('data-float')) || 0;
        var r = el.getBoundingClientRect();
        var dist = r.top + r.height / 2 - vh / 2;
        var fy = Math.max(-8, Math.min(8, -dist * sp));
        el.style.setProperty('--fy', fy.toFixed(1) + 'px');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ----- buy box gallery: thumbs swap the main viewer ----- */
    var galView = root.querySelector('[data-pv4-gal-view] img');
    var galThumbs = root.querySelectorAll('[data-pv4-gal]');
    galThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!galView) return;
        galView.removeAttribute('srcset');
        galView.removeAttribute('sizes');
        galView.src = thumb.getAttribute('data-pv4-gal');
        var timg = thumb.querySelector('img');
        if (timg) galView.alt = timg.alt || '';
        galThumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });

    /* ----- plan selector (radiogroup) ----- */
    var plans = root.querySelectorAll('[data-pv4-plan]');
    plans.forEach(function (btn) {
      btn.addEventListener('click', function () {
        plans.forEach(function (b) {
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
      });
    });

    /* ----- Pre-order: real add-to-cart + checkout (client QA row 72) -----
       Subscribe uses the product's first selling plan (created by Recharge).
       If no selling plan exists yet, the item is added one-time so the cart
       always shows the true price; the subscription discount activates
       automatically once the Recharge plan is live. */
    var checkoutBtn = root.querySelector('[data-pv4-checkout]');
    if (checkoutBtn) {
      var buyHandle = checkoutBtn.getAttribute('data-pv4-product');
      var buyProduct = null;
      var soldOut = checkoutBtn.getAttribute('data-pv4-soldout') === 'true';

      /* ----- sold out: swap CTA + show back-in-stock capture (Klaviyo) ----- */
      var bisBox = root.querySelector('[data-pv4-bis]');
      function applySoldOut() {
        soldOut = true;
        checkoutBtn.textContent = 'Sold out';
        checkoutBtn.disabled = true;
        checkoutBtn.classList.add('pv4-card__cta--soldout');
        if (bisBox) bisBox.hidden = false;
      }
      if (soldOut) applySoldOut();

      fetch('/products/' + buyHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          buyProduct = p;
          if (!soldOut && p.available === false) applySoldOut();
        })
        .catch(function () {});

      if (bisBox) {
        var bisEmail = bisBox.querySelector('[data-pv4-bis-email]');
        var bisBtn = bisBox.querySelector('[data-pv4-bis-submit]');
        var bisMsg = bisBox.querySelector('[data-pv4-bis-msg]');
        function bisSay(text, ok) {
          bisMsg.textContent = text;
          bisMsg.hidden = false;
          bisMsg.classList.toggle('is-ok', !!ok);
        }
        bisBtn.addEventListener('click', function () {
          var email = (bisEmail.value || '').trim();
          if (!email || email.indexOf('@') < 1) { bisSay('Please enter a valid email address.', false); return; }
          var variantId = buyProduct && buyProduct.variants[0].id;
          if (!variantId) { bisSay('Something went wrong \u2014 please try again.', false); return; }
          bisBtn.disabled = true;
          fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=YwHS2i', {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  channels: ['EMAIL'],
                  profile: { data: { type: 'profile', attributes: { email: email } } }
                },
                relationships: {
                  variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
                }
              }
            })
          })
            .then(function (r) {
              if (r.status >= 200 && r.status < 300) {
                bisSay('You\u2019re on the list \u2014 we\u2019ll email you the moment it\u2019s back.', true);
                bisEmail.value = '';
                fbTrack('track', 'Lead', { content_name: 'Back in stock signup' });
              } else {
                throw new Error('bis failed');
              }
            })
            .catch(function () {
              bisBtn.disabled = false;
              bisSay('Something went wrong \u2014 please try again.', false);
            });
        });
      }

      checkoutBtn.addEventListener('click', function () {
        if (soldOut) return;
        if (!buyProduct) { window.location.href = '/products/' + buyHandle; return; }

        var sel = root.querySelector('[data-pv4-plan][aria-checked="true"]');
        var subscribe = sel && sel.getAttribute('data-pv4-plan') === 'subscribe';

        var item = { id: buyProduct.variants[0].id, quantity: 1 };
        if (subscribe && buyProduct.selling_plan_groups) {
          for (var gi = 0; gi < buyProduct.selling_plan_groups.length; gi++) {
            var g = buyProduct.selling_plan_groups[gi];
            if (g.selling_plans && g.selling_plans.length) {
              item.selling_plan = g.selling_plans[0].id;
              break;
            }
          }
        }

        var oldLabel = checkoutBtn.textContent;
        checkoutBtn.disabled = true;
        checkoutBtn.textContent = 'One moment\u2026';

        fbTrack('track', 'InitiateCheckout', {
          content_name: 'Posie Sleep System Kit',
          content_type: subscribe ? 'subscription' : 'one-time',
          value: subscribe ? 135 : 205,
          currency: 'USD'
        });
        if (subscribe) {
          fbTrack('track', 'Subscribe', { value: 135, currency: 'USD', predicted_ltv: 795 });
        }
        try {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'begin_checkout', { currency: 'USD', value: subscribe ? 135 : 205 });
          }
        } catch (e) {}

        fetch('/cart/clear.js', { method: 'POST' })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [item] })
            });
          })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            checkoutBtn.disabled = false;
            checkoutBtn.textContent = oldLabel;
            window.location.href = '/products/' + buyHandle;
          });
      });
    }

    /* ----- quote rotator ----- */
    var quoteData = root.querySelector('[data-pv4-quotes]');
    var quoteText = root.querySelector('[data-pv4-quote-text]');
    var quoteCite = root.querySelector('[data-pv4-quote-cite]');
    var quoteNext = root.querySelector('[data-pv4-quote-next]');

    if (quoteData && quoteText) {
      var quotes = [];
      try {
        quotes = JSON.parse(quoteData.textContent) || [];
      } catch (err) {
        quotes = [];
      }

      if (quotes.length > 1) {
        var qi = 0;
        var timer = null;

        var show = function (index) {
          qi = (index + quotes.length) % quotes.length;
          quoteText.textContent = quotes[qi].t || '';
          if (quoteCite) quoteCite.textContent = quotes[qi].c || '';
        };

        var restart = function () {
          if (timer) clearInterval(timer);
          if (reduceMotion) return;
          timer = setInterval(function () {
            if (document.hidden) return;
            show(qi + 1);
          }, QUOTE_INTERVAL);
        };

        if (quoteNext) {
          quoteNext.addEventListener('click', function () {
            show(qi + 1);
            restart();
          });
        }
        restart();
      }
    }

    /* ----- ingredient picker: one open at a time, click toggles ----- */
    var ingCards = root.querySelectorAll('[data-pv4-ing]');
    var ingDetail = root.querySelector('[data-pv4-ing-detail]');
    var ingPanels = root.querySelectorAll('[data-pv4-ing-panel]');
    /* On phones (single-column grid) the detail panel moves directly below
       the clicked card so the copy and the "-" stay on screen (QA row 38).
       Remember its original spot so desktop keeps the below-the-grid layout. */
    var ingHome = ingDetail
      ? { parent: ingDetail.parentNode, next: ingDetail.nextSibling }
      : null;
    var ingMobile = window.matchMedia('(max-width: 767px)');

    function setIngredient(key) {
      var anyOpen = key !== null;
      var openCard = null;
      ingCards.forEach(function (card) {
        var isOpen = card.getAttribute('data-pv4-ing') === key;
        if (isOpen) openCard = card;
        card.classList.toggle('is-open', isOpen);
        card.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        var mark = card.querySelector('[data-pv4-ing-mark]');
        if (mark) mark.textContent = isOpen ? '\u2013' : '+';
      });
      ingPanels.forEach(function (panel) {
        panel.classList.toggle('is-open', panel.getAttribute('data-pv4-ing-panel') === key);
      });
      if (ingDetail) {
        if (anyOpen && openCard && ingMobile.matches) {
          openCard.insertAdjacentElement('afterend', ingDetail);
        } else if (ingHome && ingDetail.parentNode !== ingHome.parent) {
          ingHome.parent.insertBefore(ingDetail, ingHome.next);
        }
        ingDetail.hidden = !anyOpen;
        if (anyOpen) {
          /* retrigger the entrance animation */
          ingDetail.style.animation = 'none';
          void ingDetail.offsetWidth;
          ingDetail.style.animation = '';
          /* make sure the copy is actually seen */
          ingDetail.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'nearest'
          });
        }
      }
    }

    ingCards.forEach(function (card) {
      var key = card.getAttribute('data-pv4-ing');
      var toggle = function () {
        setIngredient(card.classList.contains('is-open') ? null : key);
      };
      card.addEventListener('click', toggle);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });

    /* ----- Klaviyo newsletter signup (footer) ----- */
    var kForm = root.querySelector('[data-pv4-klaviyo]');
    if (kForm) {
      var kMsg = root.querySelector('[data-pv4-klaviyo-msg]');
      kForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (kForm.querySelector('input[name="email"]') || {}).value;
        if (!email) return;
        var btn = kForm.querySelector('button[type="submit"]');
        if (btn) btn.disabled = true;
        fetch(
          'https://a.klaviyo.com/client/subscriptions/?company_id=' +
            encodeURIComponent(kForm.getAttribute('data-company-id')),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: '2024-10-15'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: { type: 'profile', attributes: { email: email } }
                  }
                },
                relationships: {
                  list: {
                    data: { type: 'list', id: kForm.getAttribute('data-list-id') }
                  }
                }
              }
            })
          }
        )
          .then(function (res) {
            if (!res.ok) throw new Error('subscribe failed');
            fbTrack('track', 'Lead');
            window.location.assign(kForm.getAttribute('data-redirect') || '/');
          })
          .catch(function () {
            if (btn) btn.disabled = false;
            if (kMsg) {
              kMsg.hidden = false;
              kMsg.textContent = 'Something went wrong \u2014 please try again.';
            }
          });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-pv4-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pv4-root]');
    if (root) {
      root.dataset.pv4Init = '';
      init(root);
    }
  });
})();
